import { toast } from 'react-toastify';
import moment from 'moment';
import SimpleCrypto from 'simple-crypto-js';
import { accountTypeEnum, AuxDownloadOptions } from '../constants';
import * as H from 'history';
import { dragFieldsProps } from '../pages/components/DragDrop';

export function parseAccountType(accountType: number) {
   switch (accountType) {
      case accountTypeEnum.provider:
         return 'Provider';
      case accountTypeEnum.nonProvider:
         return 'Non-Provider';
      default:
         return '--';
   }
}

export function removeUnselectedItems(allList: Array<dragFieldsProps>, selected: Array<dragFieldsProps>) {
   const leftList = [...selected];
   const rightList = [...allList];

   if (!selected) {
      return rightList;
   }

   if (selected.length) {
      for (let i = 0; i < leftList.length; i++) {
         for (let j = 0; j < rightList.length; j++) {
            if (leftList[i].id === rightList[j].id) {
               const item = rightList.find((r) => r.id == leftList[i].id);
               const index = item ? rightList.indexOf(item) : null;
               if (index) {
                  rightList.splice(index, 1);
                  break;
               }
            }
         }
      }
   }

   return rightList;
}

export function handleFormCancel(from: string, to: string, history: H.History<H.LocationState>) {
   if (from) {
      history.push(from);
   } else {
      history.push(to);
   }
}

export const parseMembershipStatus = (status: string) => {
   switch (status) {
      case '0':
         return 'Inactive';
      case '1':
         return 'Pending Approval';
      case '2':
         return 'Approved';
      case '3':
         return 'Confirmed';
      default:
         return '';
         break;
   }
};

export const uuidv4 = () => {
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
         v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
   });
};

export const calculateAge = (dateString: string) => {
   // birthday is a date
   if (dateString !== '' && dateString !== null && dateString !== undefined) {
      const today = new Date();
      const birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
         age--;
      }
      return age;
   } else {
      return '';
   }
};

export const getGender = (genders: any[] | null, id: string) => {
   let sex: any;

   if (genders) {
      sex = genders.find((item: Record<string, any>) => item.Id == id);
   }

   return sex ? sex.Name : '';
};

export const capitalize = (str: string) => {
   const string = str && str.toLowerCase();
   return string ? string.charAt(0).toUpperCase() + string.slice(1) + ' ' : '';
};

export const maxAge = () => {
   const currentDate = new Date();
   const maxDate = `${currentDate.getFullYear() - 15}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

   return maxDate;
};

export const errorHandler = (error: any) => {
   const message = error.response && error.response.data && error.response.data.Message;
   const validationErrors = error.response && error.response.data && error.response.data.errors;
   const errorField = validationErrors && Object.keys(validationErrors)[0];
   const validationError = errorField && validationErrors[errorField][0];

   if (!error.response) {
      toast.error('Request Failed, Please check your network', {
         position: toast.POSITION.TOP_RIGHT,
         autoClose: 5000,
      });
   } else if (validationError) {
      toast.error(validationError, {
         position: toast.POSITION.TOP_RIGHT,
         autoClose: 5000,
      });
   } else if (message) {
      toast.error(message, {
         position: toast.POSITION.TOP_RIGHT,
         autoClose: 5000,
      });
   } else {
      toast.error('Request Failed, Please Try Again!', {
         position: toast.POSITION.TOP_RIGHT,
         autoClose: 5000,
      });
   }
};

export const formatDisplayDate = (date: string) => {
   if (!date) return '00/00/0000';

   const newDate = new Date(date);
   const year = newDate.getFullYear();
   const month = newDate.getMonth() + 1;

   const formattedDate = `${newDate.getDate().toString().padStart(2, '0')}/${month
      .toString()
      .padStart(2, '0')}/${year}`;

   return formattedDate;
};

export const getMonthName = (month: number) => {
   switch (month) {
      case 1:
         return 'January';
      case 2:
         return 'February';
      case 3:
         return 'March';
      case 4:
         return 'April';
      case 5:
         return 'May';
      case 6:
         return 'June';
      case 7:
         return 'July';
      case 8:
         return 'August';
      case 9:
         return 'September';
      case 10:
         return 'October';
      case 11:
         return 'Novemeber';
      case 12:
         return 'December';
      default:
         break;
   }
};

export const calculateAMonth = (date: any) => {
   const theDate = new Date(date);
   theDate.setDate(theDate.getDate() + 29);
   return moment(theDate).format('MM-DD-YYYY');
};

export const calculateAMonthLess = (date: any) => {
   const theDate = new Date(date);
   theDate.setDate(theDate.getDate() - 29);
   return moment(theDate).format('MM-DD-YYYY');
};

export const parseDownloadType = (downloadOption: number, title: string) => {
   const presentDate = moment(new Date()).format('MM-DD-YYYY');
   switch (downloadOption) {
      case AuxDownloadOptions.text:
         return `${title}-${presentDate}.txt'`;
      case AuxDownloadOptions.csv:
         return `${title}-${presentDate}.csv`;
      case AuxDownloadOptions.excel:
         return `${title}-${presentDate}.xlsx`;
      case AuxDownloadOptions.doc:
         return `${title}-${presentDate}.docx`;
      case AuxDownloadOptions.pdf:
         return `${title}-${presentDate}.pdf`;
      default:
         return '';
   }
};

export const formatDateWithMonthName = (date: string) => {
   if (!date) return '';

   const newDate = new Date(date);
   const year = newDate.getFullYear();
   const month = newDate.getMonth() + 1;

   const formattedDate = `${newDate.getDate().toString().padStart(2, '0')} ${getMonthName(month)}, ${year}`;

   return formattedDate;
};

export const getAccurateGreeting = () => {
   const time = new Date();
   if (time.getHours() < 12) {
      return 'Good Morning';
   } else if (time.getHours() > 12 && time.getHours() < 17) {
      return 'Good Afternoon';
   } else {
      return 'Good Evening';
   }
};

export const objectDiff: any = (objs: Record<string, any>[], keys: any[]) => {
   const match = keys.map((key: string | { type: 'date'; name: string }) => {
      if (typeof key === 'object' && key.type === 'date') {
         return moment(objs[0][key.name]).format('MM/DD/YYYY') === moment(objs[1][key.name]).format('MM/DD/YYYY')
            ? undefined
            : key.name;
      }

      const newKey: any = key;

      return objs[0][newKey].toLowerCase().trim() === objs[1][newKey].toLowerCase().trim() ? undefined : key;
   });

   return match.filter((value) => value);
};

export const validQuantity = (value: string) => {
   const newValue = parseFloat(value);
   const testValue = String(newValue);

   if (testValue.length > 11) {
      return false;
   }

   if (newValue % 1) {
      const testDecimal = String(newValue).split('.')[1];
      if (testDecimal.length > 4) {
         return false;
      }
   }

   return true;
};

export function changeNullToString(value: Record<string, any>) {
   return value === null ? '' : value;
}

export const getPhoneNumber = (numbers: { Qualifier: string; Number: string }[]) => {
   const data = numbers.find((num) => num.Qualifier === 'TE' || num.Qualifier === 'CP');
   return data?.Number;
};

export const getFax = (numbers: { Qualifier: string; Number: string }[]) => {
   const data = numbers.find((num) => num.Qualifier === 'FX');
   return data?.Number;
};

export const returnNaForNull = (data: any) => {
   if (data) {
      return data;
   } else {
      return 'N/A';
   }
};

export const replaceObjectNullValues = (obj: Record<string, any>) => {
   const objectKeys = Object.keys(obj);
   const newObj: Record<string, any> = {};
   for (let i = 0; i < objectKeys.length; i++) {
      const key = objectKeys[i];
      const value = obj[key];
      if (value === null || value === undefined) {
         newObj[key] = '';
      } else {
         newObj[key] = obj[objectKeys[i]];
      }
   }
   return newObj;
};

export const regexValidation = (e: KeyboardEvent, regex: RegExp) => {
   if (!regex.test(e.key)) {
      e.preventDefault();
      e.stopPropagation();
   }
};

type Permission = { Id?: string; PermissionCode: string; PermissionName: string };
type ListItem = {
   index: number;
   permissions: Permission[] | Permission;
   all?: boolean;
};
type CheckList = ListItem[];

export const checkPermission = (permission: Permission[] | Permission, all?: boolean) => {
   const userPermissions = getItemStore('AUTOMEDSYS_ACCESS');

   if (Array.isArray(permission)) {
      const permissions: Permission[] = permission;

      const check = (permission: Permission) =>
         userPermissions?.find((item: any) => item.PermissionCode === permission.PermissionCode);

      return all ? permissions.every(check) : permissions.some(check);
   }

   return userPermissions?.find((item: Permission) => item.PermissionCode === permission.PermissionCode);
};

export const AuthorizeSideBarItems = (checkList: CheckList, menuItems: any[]) => {
   const hide: any[] = [];
   checkList.map((check: ListItem) => {
      const allowed = checkPermission(check.permissions, check.all);

      if (!allowed) {
         hide.push(check.index);
      }
   });

   return menuItems.filter((item: any, index: number) => !hide.includes(index));
};

export const HideComponentA = (Component: any, permissions: Permission[], all?: boolean) => {
   const allowed = checkPermission(permissions, all);

   return allowed ? Component : null;
};

export const HideComponentB = (Component: any, permission: Permission) => {
   const allowed = checkPermission(permission);

   return allowed ? Component : null;
};

export const returnErrorToast = (errors: Record<string, any>) => {
   const errorKeys = Object.keys(errors);
   toast.error(errorKeys.map((key) => errors[key]).join(', '));
};

export const setItemStore = (key: string, data: any) => {
   const _secret = process.env.REACT_APP_SECRET;
   const simpleCrypto = new SimpleCrypto(_secret);

   const payload = simpleCrypto.encrypt(data);
   sessionStorage.setItem(key, payload);
};

export const getItemStore = (key: string) => {
   const _secret = process.env.REACT_APP_SECRET;
   const simpleCrypto = new SimpleCrypto(_secret);

   const data = sessionStorage.getItem(key);

   const result: any = data ? simpleCrypto.decrypt(data) : null;
   return result;
};
